var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d2-container',[_c('template',{slot:"header"},[_vm._v(_vm._s(`${_vm.$t('pub.pageHeader.demo')} 2`))]),_c('DemoI18nControl'),_c('DemoI18n')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }